/**
 * Curated source entities for the create-projection wizard.
 *
 * The full Headlight meadow set is ~300 entities, mostly join/audit/system tables that are noise as a
 * projection source. This curated list surfaces the main operational + document entities a user would
 * project from, each pre-stamped with its DefaultIdentifier (for the GUID-template default). Field lists
 * are fetched live per entity from /1.0/<Entity>/Schema — only the entity choices are curated here.
 *
 * `FormData: true` marks the entity whose rows carry dynamic, manifest-driven form fields (Document) — the
 * Tier-2 flow projects FormData.<key> paths sourced from the chosen DocumentType's ArtifactType schema,
 * rather than the meadow columns.
 */

const DATALAKE_SOURCE_ENTITIES =
[
	{ Entity: 'Document', Label: 'Documents (field data)', DefaultIdentifier: 'IDDocument', FormData: true },
	{ Entity: 'Project', Label: 'Projects', DefaultIdentifier: 'IDProject' },
	{ Entity: 'Contract', Label: 'Contracts', DefaultIdentifier: 'IDContract' },
	{ Entity: 'Organization', Label: 'Organizations', DefaultIdentifier: 'IDOrganization' },
	{ Entity: 'User', Label: 'Users', DefaultIdentifier: 'IDUser' },
	{ Entity: 'Observation', Label: 'Observations', DefaultIdentifier: 'IDObservation' },
	{ Entity: 'ObservationManifest', Label: 'Observation Types', DefaultIdentifier: 'IDObservationManifest' },
	{ Entity: 'Sample', Label: 'Samples', DefaultIdentifier: 'IDSample' },
	{ Entity: 'TestInstance', Label: 'Test Instances', DefaultIdentifier: 'IDTestInstance' },
	{ Entity: 'Material', Label: 'Materials', DefaultIdentifier: 'IDMaterial' },
	{ Entity: 'PayItem', Label: 'Pay Items', DefaultIdentifier: 'IDPayItem' },
	{ Entity: 'ReportNamedInstance', Label: 'Document Types', DefaultIdentifier: 'IDReportNamedInstance' },
];

module.exports = { DATALAKE_SOURCE_ENTITIES };
